module.exports = __webpack_public_path__ + "static/media/Financing-offer-used-english.98f6bd72.png";